module.exports = __webpack_public_path__ + "img/resume-diagnosis-title2.551ad4b2.png";